export const useUserDocumentsStore = () => {
  const uid = useCurrentUID();

  if (!uid) {
    throw new Error("No user is signed in");
  }

  return useUserDocuments(uid)();
};
